<template>
  <div class="table32">
    <el-table :data="list" height="850" style="width: 100%" ref="table" @sort-change='sortChange'>
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.ths_stock_short_name_stock }}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_online_sucess_rate_of_issue_stock" label="中签率" sortable='custom' align="center">
        <template slot-scope="scope">
          {{scope.row.ths_online_sucess_rate_of_issue_stock || '--'}} <i v-if="scope.row.ths_online_sucess_rate_of_issue_stock">%</i>
        </template>
      </el-table-column>
      <el-table-column prop="ths_ipo_date_stock" label="上市日期" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.ths_ipo_date_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="that_public_issue_price" label="公开发行市值(亿元)" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.that_public_issue_price || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_close_on_debut_stock" label="开板收盘价" align="center">
        <template slot-scope="scope">
          {{scope.row.ths_close_on_debut_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="single_sign_income" label="单签收益(元)" align="center">
        <template slot-scope="scope"> {{ scope.row.single_sign_income || '--'}}</template>
      </el-table-column>
      <el-table-column prop="data7" label="操作" align="center">
        <template>
          <img src="../../../../public/img/index3/add.png" alt="" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {newStockListed} from '../../../http/index.js'
export default {
  props:{
    
  },
  data() {
    return {
      list:[],
      page:1,
      page_number:20,
      sortObj:{
        sort:'ths_ipo_date_stock desc'
      },

    };
  },

  mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 350 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){
      let obj = this.sortObj
      let params = Object.assign({},{page:this.page,page_number:this.page_number},obj)
      newStockListed(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
        }else{
          this.list = this.list.concat(res.data.list)
        }
      })
    },
    sortChange(a){
      this.page = 1
      this.list = []
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}
        this.getlist()
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.sortObj = obj
        this.getlist()
      }
    }
  }
};
</script>

<style scoped>
.table32 {
  min-width: 1427px;
  position: relative;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table32 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table32 /deep/ .cell {
  padding: 0;
}
.table32 /deep/ .el-table th.el-table__cell > .cell {
  padding: 0;
}
</style>